export default function isElementInViewport( el, threshold = false ) {
	threshold = threshold || 0

	let rect = el.getBoundingClientRect(),
		viewHeight = Math.max( document.documentElement.clientHeight, window.innerHeight ),
		above = rect.bottom + threshold < 0,
		below = rect.top - viewHeight - threshold >= 0

	return ! above && ! below
}



// WEBPACK FOOTER //
// ./utilities/isElementInViewport.jsx